module.exports = "/_next/static/images/DefineDetectValidate@2x-abafe29817cbcbb3f86bc1f141ac6953.webp";